import { Opacity } from "../Animations/Opacity";
import { PointOps } from "../Graphics/PointOps";
import { Constants } from "../Misc/Constants";
import { NumPair, NumPair4, Point } from "../Misc/Utils";
import { AssistiveObject } from "../Objects/AssistiveObjects/AssistiveObjectsHandler";

export class MultiSelectionBox implements AssistiveObject{
    
    private from: Point = [0,0];
    private wh: NumPair = [0,0];

    private lineDashGrey = [5,5]
    private lineDashWhite = [5,5]
    private lineDashOffset = 5
    private fillColor = 'rgb(110,120,135)' //gray
    private strokeColor = 'rgb(110,120,135)' //gray
    private strokeColor2 = 'white'

    //Returns the multiSelection box diment [x, y, w, h]
    getBox(): NumPair4{
        return [this.from[0], this.from[1], this.wh[0], this.wh[1]]
    }

    updateStartPos(from: Point){
        this.from = from;
    }

    updateEndPos(to: Point){
        this.wh = PointOps.subtract(to, this.from);
    }


    getRect() : Path2D{
        var rect = new Path2D();
        rect.rect(this.from[0], this.from[1], this.wh[0], this.wh[1]);
        return rect;
    }

    draw(canvasCtx : CanvasRenderingContext2D,  playStatus : number) : void {
        
        var rectangle = this.getRect();
        
        canvasCtx.fillStyle = this.fillColor;
        canvasCtx.globalAlpha = 0.1;
        canvasCtx.fill(rectangle);
        canvasCtx.globalAlpha = Constants.OPAQUE;

        canvasCtx.strokeStyle = this.strokeColor;
        canvasCtx.setLineDash(this.lineDashGrey);
        canvasCtx.stroke(rectangle);

        canvasCtx.strokeStyle = this.strokeColor2;
        canvasCtx.setLineDash(this.lineDashWhite);
        canvasCtx.lineDashOffset = this.lineDashOffset;
        canvasCtx.stroke(rectangle);

        canvasCtx.setLineDash([]);
        canvasCtx.lineDashOffset = 0;
    }

    
}